import { UserIcon } from "lucide-react";
import { useSelector } from "react-redux";
import { RootStateType } from "storeRedux/store";



export const UserImage=()=>{
    const {auth}=useSelector((state:RootStateType)=>state);
    const {user}=auth;

    return  user?.image? 
        <img  alt={user?.name} src={ process.env.REACT_APP_API_2_URL+""+user?.image} className="w-7 h-7 rounded-full object-cover" />
        :<div className=" w-7 h-7 rounded-full   " > <UserIcon/> </div>
}